import { IElement } from "core-integration/src/store/elements/types";
import { useTranslation } from "react-i18next";
import { OwnershipIcon } from "../../PitchControls/ElementOverlayValue/OwnershipIcon";
import styles from "../priceChanges.module.css";

const OwnershipCell = ({ element }: { element: IElement }) => {
  const { t } = useTranslation("priceChanges");

  return (
    <>
      {element.transfers_in_event !== element.transfers_out_event ? (
        <div className={styles.ownershipTrendWrapper}>
          <OwnershipIcon
            transfersIn={element.transfers_in_event}
            transfersOut={element.transfers_out_event}
          />
          {element.transfers_in_event > element.transfers_out_event
            ? t("up", "Up")
            : t("down", "Down")}
        </div>
      ) : (
        "-"
      )}
    </>
  );
};

export default OwnershipCell;
